import { render, staticRenderFns } from "./UserVertical.vue?vue&type=template&id=d2652d80"
import script from "./UserVertical.vue?vue&type=script&lang=js"
export * from "./UserVertical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports